import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import createHistory from 'history/createBrowserHistory'

import keaScenesReducer from './keaReducer'
import createStore from "./store"
import App from './components/App';
import {ThemeProvider} from 'react-jss'
import theme from "./styles/theme"
import {checkAccount} from "./actions"
//import registerServiceWorker from './registerServiceWorker';

import 'lazysizes/plugins/attrchange/ls.attrchange'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import "lazysizes"

const {store} = createStore(createHistory(), keaScenesReducer)

store.dispatch(checkAccount())

ReactDOM.hydrate(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App/>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root'),
    () => {
        // We don't need the static css any more once we have launched our application.
        const ssStyles = document.getElementById('server-side-styles')
        if( ssStyles ) ssStyles.parentNode.removeChild(ssStyles)

        const ssSprites = document.getElementById('server-side-sprites')
        if( ssSprites ) ssSprites.parentNode.removeChild(ssSprites)

        if (ssStyles) {
            //store.dispatch({type: REHYDRATED});
        }

    });

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./components/App', () => {
        const NextApp = require('./components/App').default
        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <NextApp />
                </ThemeProvider>
            </Provider>,
            document.getElementById('root')
        )
    })
}


// WEBPACK FOOTER //
// ./src/index.js